<div class="input-group">
	<span class="input-group-text">
		@if(hasError()){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
		@else{<i class="fa-fw fa-regular fa-user"></i>}
	</span>
	<div class="form-floating">
		<div class="form-control position-relative" #searchField id="searchPerson">
			<span>{{selectedPersonName() ? selectedPersonName() : (selectedRow ? selectedRow.displayName : 'Select a Person...')}}</span>
			<button (click)="search()" class="btn position-absolute top-0 end-0 mt-2 me-2" [ngClass]="selectedRow ? 'btn-secondary' : 'btn-success'" [disabled]="disabled()">
				<i class="fa-regular fa-magnifying-glass"></i>
			</button>
		</div>
		<label class="color-gray" for="searchPerson">
			{{searchLabel()}}
		</label>
	</div>
</div>

@if(hasError())
{
<div class="color-darkred text-end">Required Field</div>
}